import React from 'react';
import { Button } from './ui/button';
import { FileText, Calendar, ChevronDown } from 'lucide-react';
import { restaurantInfo } from '../data/mock';

export const Hero = () => {
  const scrollToNext = () => {
    const element = document.getElementById('rigorosamente-italiano');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Parallax Effect */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_briganti-resto/artifacts/y56362gb_PHOTO-2022-05-25-14-45-53.jpeg"
          alt="La Bottega Dei Briganti"
          className="w-full h-full object-cover scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Noise Texture Overlay */}
      <div className="absolute inset-0 z-[1] opacity-[0.03] mix-blend-overlay" 
           style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'3\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\'/%3E%3C/svg%3E")' }}>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-10">
          {/* Tagline */}
          <div className="inline-flex flex-col items-center gap-3">
            <div className="h-px w-12 bg-amber-400"></div>
            <p className="text-amber-400 text-sm md:text-base font-medium tracking-[0.3em] uppercase">
              {restaurantInfo.tagline}
            </p>
            <div className="h-px w-12 bg-amber-400"></div>
          </div>

          {/* Main Title */}
          <div className="relative">
            <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold text-white leading-none tracking-tight" 
                style={{ fontFamily: "'Staatliches', cursive", textShadow: '0 4px 20px rgba(0,0,0,0.5)' }}>
              LA BOTTEGA
              <br />
              <span className="text-amber-400">DEI BRIGANTI</span>
            </h1>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto font-light leading-relaxed">
            {restaurantInfo.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-5 justify-center items-center pt-6">
            <a href={restaurantInfo.menuPdfUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto">
              <Button
                size="lg"
                className="bg-amber-500 hover:bg-amber-600 text-black font-bold px-10 py-7 text-base shadow-2xl hover:shadow-amber-500/50 hover:scale-105 transition-all duration-300 w-full group"
                style={{ fontFamily: "'Staatliches', cursive", letterSpacing: '0.05em' }}
              >
                <FileText className="w-5 h-5 mr-3 group-hover:rotate-12 transition-transform" />
                SCOPRI IL MENU
              </Button>
            </a>
            <a href={restaurantInfo.bookingUrl} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto">
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-black font-bold px-10 py-7 text-base shadow-2xl hover:scale-105 transition-all duration-300 w-full group"
                style={{ fontFamily: "'Staatliches', cursive", letterSpacing: '0.05em' }}
              >
                <Calendar className="w-5 h-5 mr-3 group-hover:scale-110 transition-transform" />
                PRENOTA ORA
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-white/70 hover:text-amber-400 transition-colors duration-300 cursor-pointer group"
        aria-label="Scroll to next section"
      >
        <span className="text-xs uppercase tracking-widest">Scorri</span>
        <ChevronDown className="w-6 h-6 animate-bounce group-hover:text-amber-400" />
      </button>
    </section>
  );
};
